import React from "react";
import ShareButton from "../ShareButton.jsx";

const WhatsAppButton = ({ mediaShareURL, shareText, mediaType, gameData, sectionName, showLabel=false }) => {
  let utm = "";
  if (sectionName === "Action Replay") {
    utm = "utm_source=Stories&utm_medium=whatsapp_share&utm_campaign=action_replay";
  } else if (sectionName === "Group Photo") {
    utm = "utm_source=Stories&utm_medium=whatsapp_share&utm_campaign=group_photo";
  } else if (sectionName === "Games") {
    utm = "utm_source=Stories&utm_medium=whatsapp_share&utm_campaign=game_badge";
  } else if (sectionName === "Loop Cams") {
    utm = "utm_source=Stories&utm_medium=whatsapp_share&utm_campaign=loop_cam";
  }

  const getIconSource = (sectionName) => {
    if (sectionName === "Full Story") {
      return "./img/whatsappStoryLink.svg"; // Icon for sharing full story
    }
    return "./img/share_icon_whatsapp.svg"; // Default white icon for others
  };

  const separator = mediaShareURL.includes("?") ? "&" : "?";
  const fullUrl = mediaShareURL + separator + utm;
  const encodedUrl = encodeURIComponent(`${shareText} ${fullUrl}`);
  const iconSource = getIconSource(sectionName);

  return (
    <ShareButton
      onClick={() => window.open(`https://api.whatsapp.com/send?text=${encodedUrl}`)}
      source={iconSource}
      btnName="WhatsApp"
      mediaType={mediaType}
      gameData={gameData}
      sectionName={sectionName}
      btnLabel={showLabel ? "Whatsapp" : ""}
    />
  );
};

export default WhatsAppButton;
